/***************************************************************************************************
** useConfig
***************************************************************************************************/

import { useMemo, useState } from "react";
import { useDeepCompareEffect } from "react-use";
import { isObjectEmpty } from "@utils";

export default function useConfigFile(path, options = {}) {
  const defaults = useMemo(() => options.defaults || {}, [options.defaults]);
  const overrides = useMemo(() => options.overrides || {}, [options.overrides]);

  const [config, setConfig] = useState({ ...defaults, ...overrides });
  const [isConfigLoaded, setIsConfigLoaded] = useState(false);

  useDeepCompareEffect(() => {
    setIsConfigLoaded(false);

    if (path) {
      import(`./../../config/${path}.yml`).then((module) => {
        setConfig({
          ...defaults,
          ...module.default,
          ...overrides,
        });

        setIsConfigLoaded(true);
      }).catch((error) => {
        console.error(`[useConfigFile] Failed to load config "${path}":`, error);
        window.rollbar?.error(`[useConfigFile] Failed to load config "${path}"`, { error: error.message });

        setIsConfigLoaded(true);
      });
    } else {
      setConfig({ ...defaults, ...overrides });

      setIsConfigLoaded(true);
    }
  }, [path, defaults, overrides]);

  const isConfigPresent = useMemo(() => !isObjectEmpty(config), [config]);

  return [
    config,
    isConfigLoaded,
    isConfigPresent,
  ];
}
